module.exports = __webpack_public_path__ + "img/bg@2x.ce6eafed.png";